"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Constants: () => Constants,
  DatabaseError: () => DatabaseError,
  DatabaseQueryError: () => DatabaseQueryError,
  TABLES: () => TABLES,
  createSupabaseClient: () => createSupabaseClient
});
module.exports = __toCommonJS(index_exports);

// src/supabase/tables.ts
var TABLES = {
  FEEDBACK: "feedback"
  // Add other tables here as they are created
};

// src/supabase/types/database.types.ts
var Constants = {
  graphql_public: {
    Enums: {}
  },
  public: {
    Enums: {}
  }
};

// src/supabase/createSupabaseClient.ts
var import_supabase_js = require("@supabase/supabase-js");

// src/errors.ts
var import_core = require("@fretgenius/core");
var DatabaseError = class extends import_core.BaseError {
  constructor(message, code = "DATABASE_ERROR", details) {
    super(message, code, details);
  }
};
var DatabaseQueryError = class extends DatabaseError {
  constructor(message, details) {
    super(message, "DB_QUERY_FAILED", details);
  }
};

// src/supabase/createSupabaseClient.ts
function createSupabaseClient(config) {
  const { url, anonKey, options } = config;
  if (!url || !anonKey) {
    throw new DatabaseError(
      "Supabase URL and Anon Key are required for client creation.",
      "DATABASE_CONFIG_ERROR",
      { providedUrl: !!url, providedKey: !!anonKey }
    );
  }
  return (0, import_supabase_js.createClient)(url, anonKey, options);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Constants,
  DatabaseError,
  DatabaseQueryError,
  TABLES,
  createSupabaseClient
});
//# sourceMappingURL=index.js.map